import { useParams } from 'react-router';
import PageHeader from '../core/headers/PageHeader';

export interface IToBeCreatedProps {
    pageTitle: string;
}

export default function ToBeCreated({ pageTitle }: IToBeCreatedProps) {
    const params = useParams();

    return (
        <div>
            <PageHeader title={pageTitle} />
            <h1>{pageTitle}</h1>
            <div>{params && <pre>{JSON.stringify(params, null, 2)}</pre>}</div>
            <p>This page has not been created yet.</p>
        </div>
    );
}
